import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles/question.module.scss'
import { QuestionProps } from '../constants/types'
import { ListType } from '../constants/enums'
import { State } from '../../../dataStore/reducers/reducerType'
import Icon, { IconType } from '@bt-react/components/Icon'
import TooltipWrapper from '@bt-react/components/TooltipWrapper'
import utcToZonedTime from 'date-fns-tz/utcToZonedTime'
import format from 'date-fns/format'
import classNames from 'classnames'
import { setQuestionsAnsweredOrPriority } from '../../../dataStore/actions/questions/questions'

const QuestionItem = ({ question, showUnreadNotification, listType, handleReplyClick, handleQuestionIconClick }: QuestionProps) => {
  const [ isSettingPriorityOrAnswered, setIsSettingPriorityOrAnswered ] = useState({
    loadingPriority: false,
    successPriority: false,
    errorPriority: false,
    loadingAnswered: false,
    successAnswered: false,
    errorAnswered: false,
  })
  const dispatch = useDispatch<any>()
  const timeZone = useSelector((state: State) => state.user.data.timeZone)

  const questionTime = timeZone
    ? utcToZonedTime(question.created, timeZone)
    : question.created

  const handleViewReplyClick = () => {
    handleReplyClick && handleReplyClick(question.uniqueConversationName)
  }

  const handlePriorityIconQuestionClick = async (settingPriority: boolean, stickyOrAnswered: boolean) => {

    if (settingPriority) setIsSettingPriorityOrAnswered({
      ...isSettingPriorityOrAnswered,
      loadingPriority: true
    })
    else setIsSettingPriorityOrAnswered({
      ...isSettingPriorityOrAnswered,
      loadingAnswered: true
    })

    const result = await handleQuestionIconClick(question.uniqueConversationName, settingPriority, stickyOrAnswered)

    if (result) {

      setTimeout(() => {
        if (settingPriority) setIsSettingPriorityOrAnswered({
          ...isSettingPriorityOrAnswered,
          loadingPriority: false,
          successPriority: true
        })
        else setIsSettingPriorityOrAnswered({
          ...isSettingPriorityOrAnswered,
          loadingAnswered: false,
          successAnswered: true
        })
      }, 1000)

      setTimeout(() => {
        if (settingPriority) setIsSettingPriorityOrAnswered({
          ...isSettingPriorityOrAnswered,
          successPriority: false
        })
        else setIsSettingPriorityOrAnswered({
          ...isSettingPriorityOrAnswered,
          successAnswered: false
        })
      }, 2000)

      dispatch(setQuestionsAnsweredOrPriority(question.uniqueConversationName, settingPriority))

    } else {

      if (settingPriority) setIsSettingPriorityOrAnswered({
        ...isSettingPriorityOrAnswered,
        errorPriority: true
      })
      else setIsSettingPriorityOrAnswered({
        ...isSettingPriorityOrAnswered,
        errorAnswered: true
      })

      setTimeout(() => {
        if (settingPriority) setIsSettingPriorityOrAnswered({
          ...isSettingPriorityOrAnswered,
          errorPriority: false
        })
        else setIsSettingPriorityOrAnswered({
          ...isSettingPriorityOrAnswered,
          errorAnswered: false
        })
      }, 2000)
    }
  }

  return (
    <div className={styles['side-panel-framework__content__question']} data-bdd='question'>
      <div className={styles['question-list__question__heading']}>
        {<div className={styles['question-list__question__question-user']}>{question.user?.name}</div>}
        <time className={styles['side-panel-framework__content__question-time']} dateTime={format(questionTime, 'HH:mm')}>
          {format(questionTime, 'HH:mm')}
        </time>
      </div>
      {<div className={styles['question-list__question__question-user-company']}>{question.user?.companyName ? `${question.user.companyName}` : ''}</div>}
      <p>{question.text}</p>
      {
        question.messages.length - 1 === 0 ?
        <button
          data-bdd='question-view-reply-button'
          className={styles['question-list__question__question-reply-btn']}
          onClick={() => handleReplyClick && handleReplyClick(question.uniqueConversationName)}>
          <Icon className={styles['question-list__question__question_reply-btn-icon']} name={IconType.iconName.reply} /> Reply
        </button> :
        <button
          data-bdd='question-view-reply-button'
          className={styles['question-list__question__question-reply-btn']}
          onClick={() => handleViewReplyClick()}>
            { question.messages.length - 1 > 1 ? `${question.messages.length - 1} replies` : `1 reply` }
            { showUnreadNotification && <span className={styles['question-list__question__question_unread-replies']} /> }
        </button>
      }
      { listType !== ListType.ANSWERED &&
        <TooltipWrapper
          tooltipText={listType === ListType.ACTIVE ? 'Prioritize' : 'Deprioritize'}
          tooltipStyles={styles['question-list__question__pin-tooltip']}
          accountForScrollbar>
          <button
            data-bdd={`${listType}-priority-button`}
            className={classNames(styles['question-list__question__manage-button-pin'], listType === ListType.PRIORITY && styles['question-list__question__manage-button-pin--priority'])}
            onClick={() => handlePriorityIconQuestionClick(true, !question.isSticky)}>
            <div>
              {
                isSettingPriorityOrAnswered.loadingPriority && <Icon name={IconType.iconName.spinner } />
              }
              {
                isSettingPriorityOrAnswered.successPriority && <Icon name={IconType.iconName.spinner } />
              }
              {
                isSettingPriorityOrAnswered.errorPriority && <Icon name={IconType.iconName.close } />
              }
              {
                !isSettingPriorityOrAnswered.loadingPriority && !isSettingPriorityOrAnswered.successPriority && !isSettingPriorityOrAnswered.errorPriority &&
                <Icon name={listType === ListType.ACTIVE ? IconType.iconName.pin : IconType.iconName.pinWithSlash} />
              }
            </div>
          </button>
        </TooltipWrapper>
      }
      <TooltipWrapper
        tooltipText={listType === ListType.ANSWERED ? 'Mark as unanswered' : 'Mark as answered'}
        tooltipStyles={styles['question-list__question__manage-tooltip']}
        accountForScrollbar>
        <button
          data-bdd={`${listType}-answered-button`}
          className={styles['question-list__question__manage-button-answered']}
          onClick={() => handlePriorityIconQuestionClick(false, !question.isAnswered)}>
          {
            isSettingPriorityOrAnswered.loadingAnswered && <Icon name={IconType.iconName.spinner } />
          }
          {
            isSettingPriorityOrAnswered.successAnswered && <Icon name={IconType.iconName.spinner } />
          }
          {
            isSettingPriorityOrAnswered.errorAnswered && <Icon name={IconType.iconName.close } />
          }
          {
            !isSettingPriorityOrAnswered.loadingAnswered && !isSettingPriorityOrAnswered.successAnswered && !isSettingPriorityOrAnswered.errorAnswered &&
            <Icon name={listType === ListType.ANSWERED ? IconType.iconName.undo : IconType.iconName.tick} />
          }
        </button>
      </TooltipWrapper>
    </div>
  )
}

export default QuestionItem
